import React from 'react'
import { useSelector } from 'react-redux'
import classnames from 'classnames'
import PropTypes from 'prop-types'

// Selectors
import { selectCustomerPhotoUri } from '../../../../store/selectors/customerProfile'

// Components
import { Avatar, Text } from '../../..'
import Copy from './Copy'

// Styles
import styles from './Outreach.module.scss'

const propTypes = {
  extreme: PropTypes.bool,
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

const Outreach = ({ extreme, amount, className, high, low }) => {
  const contactPhoto = useSelector(selectCustomerPhotoUri)

  return (
    <div className={classnames(styles.root, className)}>
      <Avatar src={contactPhoto} className={styles.avatar} />
      <Text className={styles.text} variant='neutralCool' variantCount='900'>
        <Copy.Head extreme={extreme} high={high} low={low} />
      </Text>
      <Text className={styles.text} size='s' variant='neutralCool' variantCount='700'>
        <Copy.Body extreme={extreme} amount={amount} />
      </Text>
    </div>
  )
}

Outreach.propTypes = propTypes

export default Outreach
